import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'highlights'
})
export class HighlightsPipe implements PipeTransform {

  constructor() { }

  transform(text: any, term: string): any {
    const cleanTEXT = text.replace(/<(?:.|\n)*?>/gm, "");
    if (!term) {
      const excerpt = cleanTEXT.substring(0, 300);
      return excerpt + "...";
    }
    const termPosition = text.indexOf(term);
    if (termPosition===-1) {      
      const excerpt = this.highlightQuery(cleanTEXT.substring(0, 300), term);
      return excerpt + "...";
    }
    const sizeText = text.length;
    var posInitial = termPosition - 149;
    var differencePosFinal = sizeText - (termPosition + 150);
    var posFinal = (termPosition + 150);

    if (posInitial >= 0) {
      if (differencePosFinal >= 0) {
        const excerpt = this.highlightQuery(cleanTEXT.substring(posInitial, posFinal), term);
        return excerpt + "...";
      } else {
        const excerpt = this.highlightQuery(cleanTEXT.substring(posInitial, posFinal - differencePosFinal), term);
        return excerpt + "...";
      }
    } else if (posInitial < 0) {
      if (differencePosFinal < 0) {
        const excerpt = this.highlightQuery(cleanTEXT.substring(posInitial, posFinal - posFinal), term);
        return excerpt + "...";
      } else {
        const excerpt = this.highlightQuery(cleanTEXT.substring(posInitial, posFinal), term);
        return excerpt + "...";
      }
    }


  }

  highlightQuery(string, term) {
    const regex = new RegExp(term, "gi");
    const match = string.match(regex)
    if (!match) {
      return string;
    }
    return string.replace(regex, `<span class='highlightedText'>${match[0]}</span>`);
  }


}
